import { render } from "./CustomerWalletTransactions.vue?vue&type=template&id=4a92a926&scoped=true"
import script from "./CustomerWalletTransactions.vue?vue&type=script&lang=js"
export * from "./CustomerWalletTransactions.vue?vue&type=script&lang=js"

import "./CustomerWalletTransactions.vue?vue&type=style&index=0&id=4a92a926&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a92a926"]])

export default __exports__